// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cards {
  padding: 3rem;
  width: 65%;
  margin-top: 3rem;
  background: #FFFFFF30;

  display: grid;
  gap: 2rem;

  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  border-radius: 5px;

  .card {
    color: black;
    padding: 1rem;
    padding-bottom: 0;
    border-radius: 5px;
    background: gold;
    outline: 2px solid black;

    img {
      width: 100%;
      height: auto;
    }

    hr {
      width: 100%;
      border: 1px solid #00000099;
      border-radius: 2px;
    }

    div {
      padding-left: 7px;

      p:first-child {
        margin-top: 0;
        margin-bottom: 0;
        font-size: 1.15rem;
      }

      p:nth-child(2) {
        margin-top: 5px;
        font-weight: 500;

        &::before {
          content: "\$ ";
          font-weight: bold;
        }
      }
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/menu/menu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,qBAAqB;;EAErB,aAAa;EACb,SAAS;;EAET,4DAA4D;EAC5D,kBAAkB;;EAElB;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;;IAExB;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,2BAA2B;MAC3B,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;;MAEjB;QACE,aAAa;QACb,gBAAgB;QAChB,kBAAkB;MACpB;;MAEA;QACE,eAAe;QACf,gBAAgB;;QAEhB;UACE,aAAa;UACb,iBAAiB;QACnB;MACF;IACF;EACF;AACF","sourcesContent":[".cards {\n  padding: 3rem;\n  width: 65%;\n  margin-top: 3rem;\n  background: #FFFFFF30;\n\n  display: grid;\n  gap: 2rem;\n\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  border-radius: 5px;\n\n  .card {\n    color: black;\n    padding: 1rem;\n    padding-bottom: 0;\n    border-radius: 5px;\n    background: gold;\n    outline: 2px solid black;\n\n    img {\n      width: 100%;\n      height: auto;\n    }\n\n    hr {\n      width: 100%;\n      border: 1px solid #00000099;\n      border-radius: 2px;\n    }\n\n    div {\n      padding-left: 7px;\n\n      p:first-child {\n        margin-top: 0;\n        margin-bottom: 0;\n        font-size: 1.15rem;\n      }\n\n      p:nth-child(2) {\n        margin-top: 5px;\n        font-weight: 500;\n\n        &::before {\n          content: \"$ \";\n          font-weight: bold;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
